// extracted by mini-css-extract-plugin
export default {"container":"loader_container__X2Yqa","lds-ellipsis1":"loader_lds-ellipsis1__JPzUy","lds-ellipsis2":"loader_lds-ellipsis2__vqelO","lds-ellipsis3":"loader_lds-ellipsis3__db+O+"};